'use strict';/* global define:false, console:false */define('modules/icons/providers/icon-src',['require'],function(require){'use strict';// @ngInject
provider.$inject = ["APP_MODE"];
function provider(APP_MODE){// jshint validthis:true
// jshint latedef:false
this.setPath=setPath;this.$get=function(){return{getPath:getPath};};// ---
var paths={svg:'/'+APP_MODE+'/images/icons/'};function setPath(type,path){paths[type]=path;}function getPath(type,name,extension){var output=paths[type];if(!name){return output;}output+=name;if(extension){output+=extension;}return output;}}return provider;});
